import { figuress, Colors } from "../../config/index";
import { createSlice } from "@reduxjs/toolkit";

const getInitialFigures = () => JSON.parse(JSON.stringify(figuress));

const initialState = {
  color: Colors.WHITE,
  figures: getInitialFigures(),
  gameWon: null,
  isGameStarted: false,
};

export const game = createSlice({
  name: "game",
  initialState,
  reducers: {
    changeFigurePosition: (state, action) => {
      if (state.figures[action.payload.figure.id]) {
        state.figures[action.payload.figure.id].x = action.payload.x;
        state.figures[action.payload.figure.id].y = action.payload.y;
      }
    },
    removeFigure: (state, action) => {
      delete state.figures[action.payload.id];
    },
    setGameWon: (state, action) => {
      state.gameWon = action.payload;
    },
    resetGame: (state) => {
      state.gameWon = null;
      state.figures = getInitialFigures();
      state.isGameStarted = false;
    },
    setGameStarted: (state, action) => {
      state.isGameStarted = action.payload;
    },
  },
});

export const {
  changeFigurePosition,
  removeFigure,
  setGameWon,
  resetGame,
  setGameStarted,
} = game.actions;

export const selectFigures = (state) => state.game.figures;
export const selectGameWon = (state) => state.game.gameWon;
export const selectColor = (state) => state.game.color;

export default game.reducer;
